import React from 'react';
import {
  StyledButtonLarge,
  StyledButtonLargeDisabled,
  StyledButtonLargeOutlined,
} from './styled.buttonLarge';
import { IButton } from './../../../../@types/button';
import { Loading } from './../../../icons/Loading';
import { Headline3 } from '../../../../../app/common/typography';

export function ButtonLarge ({
  title,
  onClick,
  outlined,
  backgroundColor,
  inverted,
  disabled,
  loading,
  textColor,
  rounded,
  leftIcon,
  rightIcon,
}: IButton) {
  // title -> text inside the button
  // onClick -> function sent to parent
  // outlined -> if the button has outlined, the value must be TRUE (by default FALSE / 1px withe)
  // backgroundColor -> button color (follow the color in theme/default.ts)
  // inverted -> variable to invert the colors, this means, backgroundColor becomes outlineColor and backgroundColor becomes withe
  // disabled -> should be TRUE if the button is disabled

  if (disabled) {
    return (
      <StyledButtonLargeDisabled rounded={rounded}>
        {leftIcon || <span />}
        <Headline3 color="white">{title}</Headline3>
        {rightIcon || <span />}
      </StyledButtonLargeDisabled>
    );
  }

  if (outlined) {
    return (
      <StyledButtonLargeOutlined
        onClick={onClick}
        inverted={inverted}
        backgroundColor={backgroundColor}
        disabled={loading}
        textColor={textColor}
        rounded={rounded}
        loading={loading}
      >
        {loading ? (
          <Loading color={backgroundColor} />
        ) : (
          <>
            {leftIcon || <span />}
            <Headline3
              color={inverted ? backgroundColor : textColor || 'white'}
            >
              {title}
            </Headline3>
            {rightIcon || <span />}
          </>
        )}
      </StyledButtonLargeOutlined>
    );
  }

  return (
    <StyledButtonLarge
      onClick={onClick}
      backgroundColor={backgroundColor}
      disabled={loading}
      textColor={textColor}
      rounded={rounded}
      loading={loading}
    >
      {loading ? (
        <Loading />
      ) : (
        <>
          {leftIcon || <span />}
          <Headline3 color={textColor || 'white'}>{title}</Headline3>
          {rightIcon || <span />}
        </>
      )}
    </StyledButtonLarge>
  );
}
